'use strict';

/**
 * @classname ReviewAverage
 * @classdesc レビューの平均点を0.5単位に調整する処理
 */
export default class ReviewAverage {
	/**
	 * @constructor
	 * @param {jQuery} $e - .review-average
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
        this._$review = $e.find('.review');
		this._$reviewNum = $e.find('.review-num')
		this._controller = controller;
        this._reviewRating = $e.attr('data-review-rating');
        this._reviewCount = $e.attr('data-review-count');
		this._isItemDetail = $e.hasClass('review-average--item-detail')

        // レビューの平均点を少数第一位で四捨五入する
		const reviewAverage = this.roundRating();
        this.insertReviewAverage(reviewAverage);
	};

    /**
	 * レビュー点数を0.5単位で四捨五入する
	 *
	 * @memberof ReviewAverage
	 * @return {number} 四捨五入された点数（小数点第一位まで表示）
	 */
	roundRating(step) {
		console.log(`${this.constructor.name}.roundRating`);
		const roundStep = step ? step : 0.5;
        const invariable = 1.0 / roundStep;
        const reviewAverage = Math.round(this._reviewRating * invariable) / invariable;
        return reviewAverage.toPrecision(2);
	};

    /**
	 * 平均点と件数を挿入する
	 *
	 * @memberof ReviewAverage
	 * @return undefined
	 */
	insertReviewAverage(reviewAverage) {
		console.log(`${this.constructor.name}.insertReviewAverage`);
		const text = this._isItemDetail ? `${Number(reviewAverage)} (${this._reviewCount}件)` : `${Number(reviewAverage)} (${this._reviewCount})`;
        const classNum = reviewAverage.replace('.','');
        this._$reviewNum.text(text);
        this._$review.addClass(`review-${classNum}`);
	};
}